export class SelectedDay {
    public date: Date;
    public selected: boolean;

    constructor();
    constructor(date: Date, selected: boolean);
    constructor(date?: Date, selected?: boolean) {
        if (date) {
            this.date = date;
            this.selected = selected;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/viewModels/selectedDay-viewmodel.ts